import { format, parse } from 'date-fns';
import { ru } from 'date-fns/locale';

export const parseDate = (date: string) => parse(date, 'yyyy-MM-dd', new Date());

export const formatDateString = (dateString: string) => format(parseDate(dateString), 'dd MMM yyyy', { locale: ru });

export const formatDate = (date: Date) => format(date, 'dd MMM yyyy', { locale: ru });

export const formatTime = (time: string) => format(new Date(time), 'dd.MM.yyyy, HH:mm:ss');
